<template>
	<div class="room-page">
		<room-left-con
			ref="roomLeftCon"
			:detailPageData="detailPageData"
			:stableNum="stableNum"
			:beginColor="beginColor"
			:endColor="endColor"
			:monitorStatusStr="monitorStatusStr"
			:num="num"
			:duration="duration"
			:shouldShowEcharts="shouldShowEcharts"
		/>
		<room-right-panel
			:isShowGray="isShowGray"
			:role="role"
			:switchStatus.sync="switchStatus"
			:roomStatus="roomStatus"
			:isShowRedBreath="isShowRedBreath"
			:isShowRedHeart="isShowRedHeart"
			:breathPosition="breathPosition"
			:heartPosition="heartPosition"
			:breathBpm="breathBpm"
			:heartBpm="heartBpm"
			:editAbnormalTimePopupOutBed="editAbnormalTimePopupOutBed"
			:getFallLongTimeData="getFallLongTimeData"
			:alarmModel="alarmModel"
			:relateWC_treeData="relateWC_treeData"
			:relateWC_treeData_value="relateWC_treeData_value"
			:relateWC_treeData_value_Sel_Next="relateWC_treeData_value_Sel_Next"
			:isShowTipAlertWqsn="isShowTipAlertWqsn"
			:filterOptionFn="filterOption"
			@set-status="setStatus"
			@set-toitet="setToitet"
			@edit-abnormal-time-cancel-out-bed="editAbnormalTimeCancelOutBed"
			@switch-change-leave-bed-time="swictchChangeLeaveBedTime"
			@switch-change-leave-bed-phone="swictchChangeLeaveBedPhone"
			@handle-focus="handleFocus"
			@handle-blur="handleBlur"
			@handle-change="handleChange"
			@change-relate-wc="change_relateWC"
			@edit-abnormal-time-toitet-new-new="editAbnormalTimeToitetNewNew"
			@tip-alert-click-cancel-wqsn="tipAlertClickCancelWqsn"
			@tip-alert-click-sure-wqsn="tipAlertClickSureWqsn"
		/>
	</div>
</template>
<script>
import { createGlobalStompScope } from '@/utils/stomp';

import detaliPageConRoomCommonData2 from './detaliPageConRoomCommonData2.json'
import detaliPageConRoomCommonData3 from './detaliPageConRoomCommonData3.json'

import RoomLeftCon from './roomPanel/RoomLeftCon.vue'
import RoomRightPanel from './roomPanel/RoomRightPanel.vue'
import { createDetaliPageConRoomState } from './roomPanel/detaliPageConRoom.state'
import { waveformMethods } from './roomPanel/detaliPageConRoom.waveform'

export default {
	components: {
		RoomLeftCon,
		RoomRightPanel,
	},
	props: {
		detailPageData: {
			type: Object,
			default: () => { },
		},
		pageBottomData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return createDetaliPageConRoomState(detaliPageConRoomCommonData2, detaliPageConRoomCommonData3);
	},
	computed: {
		shouldShowEcharts() {
			const status = this.detailPageData.status;
			const subStatus = this.detailPageData.subStatus;
			const isLeaveBedScene =
				(status === 1 && subStatus === 1) ||
				((status === 5 || status === 6) && subStatus === 1);
			return Boolean(this.showEchars) && !isLeaveBedScene;
		},
	},
	created() {


		// 白天：呼吸 12-20 心跳：55-100
		// 黑夜：呼吸 8-24  心跳：40-90

		// 1.模拟呼吸400个点位
		for (let i = 0; i < 400; i++) {
			this.breathYdataCopy.push(0);
		}

		// 2.获取用户信息
		this.role = this.$getCookie('userInfo').user.roleId;

		// 3.控制右侧监测仪是否为灰色
		if (this.detailPageData.status == 3 || this.detailPageData.status == 4) {
			this.isShowGray = 1;
		} else if (
			this.detailPageData.status == 1 ||
			this.detailPageData.subStatus == 1
		) {
			this.isShowGray = 2;
		}

		// 4.初始化已离床时间
		this.duration = '';

		// 5.模拟心率600个点位
		for (let i = 0; i < 600; i++) {
			this.heartXdata.push(0);
			this.heartYdataCopy.push(0);
		}

		// 6.模拟呼吸400个点位
		for (let i = 0; i < 400; i++) {
			this.breathXdata.push(0);
		}

		// 7.心率替换数组 - 固定 - 20个空字符串
		for (let i = 0; i < 20; i++) {
			this.replaceArr.push('');
		}

		// 8.判断是否已离床
		if (
			(this.detailPageData.status == 5 || this.detailPageData.status == 6) &&
			this.detailPageData.subStatus == 1
		) {
			// this.monitorStatusStr = '已离床';
			this.monitorStatusStr = this.detailPageData.statusName;
		}

		// 9.初始化是否显示图表
		this.showEchars = this.detailPageData.showEchars;

		// 10.获取床位信息
		// this.getBedInfoById(this.detailPageData.bedId);
	},
	mounted() {
		const countdownTimer = this.startInitialCountdown();
		this.showChartAfterInitialReady(countdownTimer);
		this.initRoomLeftCharts();
		this.initRealtimeSockets();
	},
	methods: {
		isSocketActive(client) {
			if (!client) {
				return false;
			}
			if (client.isActive && client.isActive()) {
				return true;
			}
			if (client.isConnected && client.isConnected()) {
				return true;
			}
			if (client.getState) {
				const currentState = client.getState();
				return currentState && (currentState.state === 'connecting' || currentState.state === 'connected');
			}
			return false;
		},
		startInitialCountdown() {
			const interval = setInterval(() => {
				if (this.num > 0) {
					this.num--;
				} else {
					this.num = 0;
					clearInterval(interval);
				}
			}, 1000);
			return interval;
		},
		showChartAfterInitialReady(countdownTimer) {
			if (this.detailPageData.status === 1 && this.detailPageData.subStatus !== 1) {
				setTimeout(() => {
					this.showEchars = true;
					clearInterval(countdownTimer);
				}, 3000);
			}
		},
		initRoomLeftCharts() {
			const chartLeft = this.$refs.roomLeftCon;
			if (chartLeft && chartLeft.initCharts) {
				const chartResult = chartLeft.initCharts(this.$echarts, this.chart1, this.chart2);
				this.chart1 = chartResult.chart1;
				this.chart2 = chartResult.chart2;
			}
		},
		initRealtimeSockets() {
			if (!this.isSocketActive(this.statusStompClient)) {
				this.openStatusWebSocket();
			}
			if (!this.isSocketActive(this.stompClient)) {
				this.openWebSocket();
			}
		},
		createSocketClient(scopeName) {
			return createGlobalStompScope({
				vm: this,
				name: scopeName,
			});
		},
		parseSocketBody(body) {
			if (!body) return null;
			if (typeof body === 'string') {
				try {
					return JSON.parse(body);
				} catch (e) {
					return null;
				}
			}
			return body;
		},
		normalizeBoolean(value) {
			if (value === true || value === 1 || value === '1' || value === 'true') {
				return true;
			}
			if (value === false || value === 0 || value === '0' || value === 'false' || value === null || value === undefined || value === '') {
				return false;
			}
			return Boolean(value);
		},
		applyRealtimeFallbackStatus(socketData) {
			if (!socketData) {
				return;
			}

			if (socketData.status === 2) {
				const hasAlarm = this.normalizeBoolean(socketData.outBedAlarm);
				this.detailPageData.status = 2;
				this.detailPageData.subStatus = 1;
				this.detailPageData.hasAlarm = hasAlarm;
				this.detailPageData.statusName = hasAlarm ? '离床过久' : '离床';
			}
		},
		isChartAllowedStatus(status, subStatus) {
			return (status == 1 && subStatus != 1) || ((status == 5 || status == 6) && subStatus != 1);
		},
		tipAlertClickSureWqsn() {
			this.isShowTipAlertWqsn = false;
			this.editAbnormalTimeToitet();
		},
		tipAlertClickCancelWqsn() {
			this.isShowTipAlertWqsn = false;
		},
		setAlarmBpm() {
			this.$post(
					'/api/dean/v5/setHealthAlarmConfig',
					{
						"bedId": this.detailPageData.bedId,
						"breathFast": this.alarmModel.breathFast
					},
					(res) => {
						if (res.code == 0) {
						} else {
							this.$message.error(res.msg);
						}
					},
				(err) => {
					return;
				}
				);
		},
		handleChange(value) {
			let tempAlarmModel = JSON.parse(JSON.stringify(this.alarmModel));
			tempAlarmModel.breathFast = value;
			this.alarmModel = tempAlarmModel;
		},
		handleBlur() {
		},
		handleFocus() {
		},
		filterOption() {
			return false;
		},
		...waveformMethods,
		setLeaveBed() {

		},
		handleSocketLeaveBedAndVisibility(data) {
			if (data.obfg == true || data.status == 2 || data.status == 3 || data.status == 4) {
				this.showEchars = false;
				this.setLeaveBed();
			}

			if (data.heartBpm == '255') {
				this.showEchars = false;
				this.statusName = '离床';
				this.setLeaveBed();
			}

			if (data.status === 1) {
				this.showEchars = true;
			}
		},
		applySocketVisualState(socketData) {
			if (socketData.heartBpm >= socketData.heartStatus[0] && socketData.heartBpm <= socketData.heartStatus[1]) {
				this.circleBackground = '#53c31b';
			} else {
				this.circleBackground = '#FF4D4F';
			}

			this.roomStatus = socketData.status;
			this.computedBreathPosition(socketData.breathStatus, socketData.breathBpm);
			this.computedHeartPosition(socketData.heartStatus, socketData.heartBpm);
			this.getMonitorStatusStr(socketData);
			this.getEndColor(socketData.stableNum);

			if (socketData.status === 3 || socketData.status === 4) {
				this.isShowGray = 1;
			} else {
				this.isShowGray = 2;
			}
		},
		applySocketOutBedState(socketData) {
			if (socketData.status === 2) {
				this.showEchars = false;
				this.isBeginDrawechars = true;
				this.isOutBed = this.isOutBed + 1;
				this.breathBPM = '--';
				this.isShowRedBreath = 2;
				this.heartBPM = '--';
				this.isShowRedHeart = 2;
				if (this.isOutBed >= 1) {
					this.computedLeaveBed(socketData.duration);
				} else {
					clearInterval(this.leaveBedInterval);
					this.duration = '';
				}
			} else {
				this.isOutBed = 0;
				clearInterval(this.leaveBedInterval);
				this.duration = '';
			}

			this.detailPageData.hasAlarm = this.normalizeBoolean(socketData.outBedAlarm);
		},
		applySocketRealtimeWaveData(data) {
			this.websocketData = data;
			this.heartBpm = data.heartBpm == 255 ? '--' : data.heartBpm;
			this.breathBpm = data.breathBpm == 255 ? '--' : data.breathBpm;
			this.stableNum = data.stableNum;
			this.isShowStableNum = true;
			this.showBreatheBpm = this.breathBpm;
			this.showHeartBpm = this.heartBpm;

			if (data.stableNum > 0) {
				let tempArr = [];
				for (let j = 0; j < Math.floor(data.stableNum / 5.0); j++) {
					tempArr.push('1');
				}
				this.progressArr = tempArr;
			} else {
				this.progressArr = [];
			}

			if (!this.createDataInterval) {
				this.openTimer();
			}
		},
		applyBreathHeartDisplayState(data) {
			if (data.status == 1) {
				if (data.breathStatus.length == 2) {
					if (this.breathBpm >= data.breathStatus[0] && this.breathBpm <= data.breathStatus[1]) {
						this.breatheColor = '#1890ff';
						this.breatheImageName = 'icon_alarm_detail_state_6.png';
					} else {
						this.breatheColor = '#1890ff';
						this.breatheImageName = 'icon_alarm_detail_state_2.png';
					}
				} else {
					this.breatheColor = '#1890ff';
					this.breatheImageName = 'icon_alarm_detail_state_6.png';
				}

				if (data.heartStatus.length == 2) {
					if (this.heartBpm >= data.heartStatus[0] && this.heartBpm <= data.heartStatus[1]) {
						this.heartColor = '#52C419';
						this.heartImageName = 'icon_alarm_detail_state_1.png';
					} else {
						this.heartColor = '#53c31b';
						this.heartImageName = 'icon_alarm_detail_state_3.png';
					}
				} else {
					this.heartColor = '#52C419';
					this.heartImageName = 'icon_alarm_detail_state_1.png';
				}
			} else if (data.status == 5 || data.status == 6) {
				if (data.subStatus == 1) {
					this.breatheColor = '#FF4D4F';
					this.heartColor = '#FF4D4F';
				} else {
					if (data.breathStatus.length == 2) {
						if (this.breathBpm >= data.breathStatus[0] && this.breathBpm <= data.breathStatus[1]) {
							this.breatheColor = '#1890ff';
							this.breatheImageName = 'icon_alarm_detail_state_6.png';
						} else {
							this.breatheColor = '#FF4D4F';
							this.breatheImageName = 'icon_alarm_detail_state_2.png';
						}
					} else {
						this.breatheColor = '#1890ff';
						this.breatheImageName = 'icon_alarm_detail_state_6.png';
					}

					if (data.heartStatus.length == 2) {
						if (this.heartBpm >= data.heartStatus[0] && this.heartBpm <= data.heartStatus[1]) {
							this.heartColor = '#52C419';
							this.heartImageName = 'icon_alarm_detail_state_1.png';
						} else {
							this.heartColor = '#FF4D4F';
							this.heartImageName = 'icon_alarm_detail_state_3.png';
						}
					} else {
						this.heartColor = '#52C419';
						this.heartImageName = 'icon_alarm_detail_state_1.png';
					}
				}
			}
		},
		applyStatusSocketBaseState(socketData) {
			const prevStatus = this.detailPageData.status;
			const prevSubStatus = this.detailPageData.subStatus;
			const hasStatusChanged = prevStatus !== socketData.status || prevSubStatus !== socketData.subStatus;
			if (hasStatusChanged) {
				this.resetWaveformState();
			}
			this.detailPageData.status = socketData.status;
			this.detailPageData.subStatus = socketData.subStatus;
			this.detailPageData.statusName = socketData.statusName;
		},
		applyStatusSocketUiState(socketData) {
			if (socketData.status === 3 || socketData.status === 4) {
				this.isShowGray = 1;
				this.showEchars = false;
				clearInterval(this.intervalPulsSecond);
			} else {
				this.isShowGray = 2;
				this.showEchars = !(
					(socketData.status === 1 && socketData.subStatus === 1) ||
					((socketData.status === 5 || socketData.status === 6) && socketData.subStatus === 1)
				);
			}
		},
		applyStatusSocketTimers(socketData) {
			if (socketData.status === 2) {
				clearInterval(this.intervalPulsSecond);
				clearInterval(this.breathInterval);
				clearInterval(this.heartInterval);
			}

			if (socketData.status === 1) {
				setTimeout(() => {
					clearInterval(this.heartInterval);
					clearInterval(this.breathInterval);
					clearInterval(this.intervalPulsSecond);
					let length = this.breathYdataCopy.length;

					for (let i = 0; i < 400 - length; i++) {
						this.breathYdataCopy.push(0);
					}
				}, 10000);
			}
		},
		updateStatusShow() {
		},
		changeArithmetic(operationType) {
		},
		openWebSocket() {
			if (this.isSocketActive(this.stompClient)) {
				return;
			}
			if (this.stompClient != null) {
				this.stompClient.destroy();
				this.stompClient = null;
			}

			// 1.默认已离床时间为空
			this.duration = '';
			this.resetWaveformState();

			let id = this.detailPageData.sn;
			this.stompClient = this.createSocketClient('detail-room-realtime');

			this.stompClient.subscribe('/topic/bedRealTime.' + id, ({ body }) => {
					let data = this.parseSocketBody(body);
					if (data) {
						// this.applyRealtimeFallbackStatus(data);
						this.handleSocketLeaveBedAndVisibility(data);

						let socketData = data;
						this.applySocketVisualState(socketData);
						this.applySocketOutBedState(socketData);
						this.applySocketRealtimeWaveData(data);
						this.applyBreathHeartDisplayState(data);
					}
			});

			this.stompClient.connect();
		},

		// 状态 WebSocket
		openStatusWebSocket() {
			if (this.isSocketActive(this.statusStompClient)) {
				return;
			}
			if (this.statusStompClient != null) {
				this.statusStompClient.destroy();
				this.statusStompClient = null;
			}

			let id = this.detailPageData.bedId;
			this.statusStompClient = this.createSocketClient('detail-room-status');

			this.statusStompClient.subscribe('/topic/bedStatus.' + id, ({ body }) => {
					let socketData = this.parseSocketBody(body);
					if (socketData) {
						// 打开画线 WebSocket
						if (this.isChartAllowedStatus(socketData.status, socketData.subStatus)) {
							if (!this.isSocketActive(this.stompClient)) {
								this.openWebSocket();
							}
						}
						if ((socketData.status == 1 && socketData.subStatus == 1)) {
							this.setLeaveBed();
						}
						if (((socketData.status == 5 || socketData.status == 6) && socketData.subStatus == 1)) {
							this.setLeaveBed();
						}

						this.applyStatusSocketBaseState(socketData);
						this.applyStatusSocketUiState(socketData);
						this.applyStatusSocketTimers(socketData);

					}
			});

			this.statusStompClient.connect();
		},












		computedLeaveBed(value) {
			if (this.duration != '') {
				return
			}
			let falg = 0;
			if (this.leaveBedInterval) {
				clearInterval(this.leaveBedInterval);
			}
			if (value) {
				this.duration = this.formatSeconds(value + falg);
				this.leaveBedInterval = setInterval(() => {
					falg++;
					this.duration = this.formatSeconds(value + falg);
				}, 1000);
			}
		},
		
		// 关闭 Websocket
		closeWebsocket() {
			if (this.stompClient) {
				this.stompClient.destroy();
				this.stompClient = null;
			}
			if (this.statusStompClient) {
				this.statusStompClient.destroy();
				this.statusStompClient = null;
			}
		},
		// 获取床位信息
		getBedInfoById(bedId) {
			let params = {
				bedId: bedId,
			};
			this.$get(
				'/api/v3/bed/getBedInfoById',
				params,
				(res) => {
					if (res.code === 0) {
						if (!res.data) {
							return;
						}
						this.switchStatus =
							res.data.monitorInfoVO.onOff === 0 ? false : true;
						this.bedSetId = res.data.bedId;
						this.radarId = res.data.radarId;
					}
				},
				() => {}
			);
		},
		// 设置监测仪状态
		setStatus() {
			this.num = 10;
			let param = {
				bedId: this.detailPageData.bedId,
				onOff: this.switchStatus ? 1 : 0,
			};
			this.$put(
				'/api/monitor/onOff',
				param,
				(res) => {
					if (res.code == 0) {
						if (this.switchStatus == 1) {
							this.$message.success('监测仪已开启');
						} else {
							this.$message.success('监测仪已关闭');
						}
						this.$emit('getHistoryList');
						this.isShowGray = 1;
					}
				},
				() => {}
			);
		},
		// 卫生间停留时长取消
		editAbnormalTimeCancelOutBed() {
			this.editAbnormalTimePopupOutBed = false;
		},
		editAbnormalTimeToitetNewNew() {
			this.$get(
				'/api/bedInformation/getLivingState',
				{
					"bedId": this.detailPageData.bedId
				},
				(res) => {
					if (res.code == 0) {
						if (res.data == 4) { // 完全失能
							this.editAbnormalTimeToitetNew(true)
						} else {
							this.editAbnormalTimeToitetNew(false)
						}
					} else {
						this.editAbnormalTimeToitetNew(false)
					}
				},
				(err) => {
					this.editAbnormalTimeToitetNew(false)
				}
			);
		},
		editAbnormalTimeToitetNew(isWqsn) {

			let isChange = false;
			if (isWqsn) {
				if (this.compareOldTimePeriods && this.getFallLongTimeData && this.getFallLongTimeData.timePeriods) {
					let oldTimePeriods = JSON.parse(JSON.stringify(this.compareOldTimePeriods));
					let tempChangedTimePeriods = JSON.parse(JSON.stringify(this.getFallLongTimeData.timePeriods));
					let newTimePeriods = [];
					if (tempChangedTimePeriods.length > 0) {
						for (let i = 0; i < tempChangedTimePeriods.length; i++) {
							let needStartTime;
							let needEndTime;
							let needEditHandleTimeValOutBed = this.$dateTime(tempChangedTimePeriods[i].editHandleTimeValOutBed).time + ':' + this.$dateTime(tempChangedTimePeriods[i].editHandleTimeValOutBed).seconds;
							if (!tempChangedTimePeriods[i] || !tempChangedTimePeriods[i].editHandleTimeValOutBed) {
								needEditHandleTimeValOutBed = ''
							}
							needStartTime = this.$dateTime(tempChangedTimePeriods[i].startTime).time;
							needEndTime = this.$dateTime(tempChangedTimePeriods[i].endTime).time;
							let obj = {
								bedId: tempChangedTimePeriods[i].bedId,
								endTime: needEndTime,
								id: tempChangedTimePeriods[i].id,
								outBedAlarmTime: needEditHandleTimeValOutBed,
								startTime: needStartTime,
								outBedEnable: tempChangedTimePeriods[i].outBedEnable,
								outBedPhoneEnable: tempChangedTimePeriods[i].outBedPhoneEnable
							}
							newTimePeriods.push(obj)
						}

						if (this.compareOldTimePeriods && newTimePeriods && this.compareOldTimePeriods.length == newTimePeriods.length) {
							for (let i = 0; i < newTimePeriods.length; i++) {
								let item = newTimePeriods[i];
								let otherItem = this.compareOldTimePeriods[i];
								if (item.startTime != otherItem.startTime) {
									isChange = true;
								}
								if (item.endTime != otherItem.endTime) {
									isChange = true;
								}
								if (item.outBedAlarmTime != otherItem.outBedAlarmTime) {
									isChange = true;
								}
								if (item.outBedEnable != otherItem.outBedEnable) {
									isChange = true;
								}
								if (item.outBedPhoneEnable != otherItem.outBedPhoneEnable) {
									isChange = true;
								}
							}
						}
					}
				}
			}
			
			if (isWqsn) {
				// 1.判断监测时间段、离床异常时长是否被修改了
				if (isChange) {
					// 2.判断是否每次设置成完全是能用户后的第一次修改进行提示
					this.$get('/api/bedInformation/livingStateDoNum', {"bedId": this.detailPageData.bedId}, (res) => {
						if (res.code == 0) {
							if (res.data == 1) {
								this.isShowTipAlertWqsn = true;
							} else {
								this.editAbnormalTimeToitet();
							}
						} else {
							this.$message.error(res.msg);
						}
					},
					(err) => {
						// this.$message.error('服务端发生异常');
					});
				} else {
					this.editAbnormalTimeToitet();
				}
			} else {
				this.editAbnormalTimeToitet();
			}
		},
		// 卫生间停留时长确定
		editAbnormalTimeToitet() {
			// 1.设置呼吸过速阈值报警
			this.setAlarmBpm();

			// 2.老代码
			let len = this.relateWC_treeData_value_Sel_Next.length;
			let fallId = this.relateWC_treeData_value_Sel_Next[len - 1];
			let timePeriods = this.getFallLongTimeData.timePeriods
			let new_timePeriods = []
			if (timePeriods.length > 0) {
				for (let i = 0; i < timePeriods.length; i++) {
					let needStartTime;
					let needEndTime;
					let needOutBedAlarmTime = this.$dateTime(timePeriods[i].editHandleTimeValOutBed).time + ':' + this.$dateTime(timePeriods[i].editHandleTimeValOutBed).seconds;
					if (!timePeriods[i] || !timePeriods[i].editHandleTimeValOutBed) {
						needOutBedAlarmTime = ''
					}
					if (timePeriods[i].outBedEnable == 0 && (!timePeriods[i] || !timePeriods[i].editHandleTimeValOutBed)) {
						this.$message.error('请选择时间');
						return
					}
					needStartTime = this.$dateTime(timePeriods[i].startTime).time;
					needEndTime = this.$dateTime(timePeriods[i].endTime).time;
					let obj = {
						bedId: timePeriods[i].bedId,
						endTime: needEndTime,
						id: timePeriods[i].id,
						// outBedAlarmTime: this.$dateTime(this.editHandleTimeValOutBed._d).time + ':' + this.$dateTime(this.editHandleTimeValOutBed._d).seconds,
						outBedAlarmTime: needOutBedAlarmTime || null,
						startTime: needStartTime,
						outBedEnable: timePeriods[i].outBedEnable,
						outBedPhoneEnable: timePeriods[i].outBedPhoneEnable
					}
					new_timePeriods.push(obj)
				}
			}
			let param = {
				radarId: this.radarId,
				fallId: fallId,
				outBedTimeout: this.$dateTime(this.editHandleTimeValOutBed._d).time + ':' + this.$dateTime(this.editHandleTimeValOutBed._d).seconds,
				timePeriods: new_timePeriods
			};
			this.$post(
				'/api/radar/radarFallAndSetOutTime',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');

						this.editAbnormalTimePopupOutBed = false;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 设置卫生间停留时长
		setToitet() {
			this.$get(
				'/api/dean/v5/getHealthAlarmConfig',
				{
					"bedId": this.detailPageData.bedId
				},
				(res) => {
					if (res.code == 0) {
						this.alarmModel = null;
						setTimeout(() => {
							this.alarmModel = res.data;
							this.setToitet1();
						}, 300);
					} else {
						this.$message.error(res.msg);
					}
				},
				() => {}
			);
		},
		setToitet1() {
			this.editAbnormalTimePopupOutBed = true;
			let param = {
				bedId: this.bedSetId,
			};
			this.$get(
				'/api/app/v1/getFallLongTime',
				param,
				(res) => {
					if (res.code == 0) {
						let tempData = JSON.parse(JSON.stringify(res.data));
						if (tempData.timePeriods && tempData.timePeriods.length > 0) {
							for (let i = 0; i < tempData.timePeriods.length; i++) {
								tempData.timePeriods[i].editHandleTimeValOutBed = tempData.timePeriods[i].outBedAlarmTime ? this.$moment(tempData.timePeriods[i].outBedAlarmTime, 'HH:mm:ss') : '';
							} 
						}
						this.getFallLongTimeData = tempData
						this.OutBeddisabled = res.data.hasConsumer;
						this.editHandleTimeValOutBed = res.data.outBedTime ? this.$moment(res.data.outBedTime, 'HH:mm:ss') : '';
						this.compareOldTimePeriods = JSON.parse(JSON.stringify(this.getFallLongTimeData.timePeriods));
						
						let timePeriods = this.getFallLongTimeData.timePeriods
						if (timePeriods && timePeriods.length > 0) {
							for (let i = 0; i < timePeriods.length; i++) {
								timePeriods[i].startTime += ':00';
								timePeriods[i].startTime = this.$moment(timePeriods[i].startTime, 'HH:mm:ss');
								timePeriods[i].endTime += ':00';
								timePeriods[i].endTime = this.$moment(timePeriods[i].endTime, 'HH:mm:ss');
							}
						}
						this.getFallLongTimeData.timePeriods = timePeriods
					}
				},
				() => {}
			);
			this.getFallRelationTree();
			this.getFallRelation();
		},
		// 获取关联弹窗内树形结构
		getFallRelationTree() {
			this.$get(
				'/api/radar/getFallRelationTree',
				{},
				(res) => {
					if (res.code == 0) {
						this.relateWC_treeData = res.data.children;
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 获取查看关联
		getFallRelation() {
			this.$get(
				'/api/radar/getFallRelation',
				{
					radarId: this.radarId,
				},
				(res) => {
					if (res.code == 0) {
						this.relateWC_treeData_value = res.data; //当前值 为进入查看时的值
						this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value; //选中前的值
						this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value; //选中后的值
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 点击选择
		change_relateWC(value) {
			this.relateWC_treeData_value_Sel_Next = value; //赋值选中后的新值

			if (this.relateWcType == 1) {
				// 查看关联
				if (value.length < 1) {
					// 当前选中后为空,执行的叉子操作
					// 选中前的值等于默认的值
					if (
						this.relateWC_treeData_value_Sel_Prev ==
						this.relateWC_treeData_value
					) {
						this.del_relateWC_Tan = true; //二次确认弹窗
					}
				} else {
					//如果不为空，为赋值操作，选中后的值赋值给选中前的值
					this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value_Sel_Next;
				}
			}
		},
		// 获取设备当前状态的描述文案
		getMonitorStatusStr(resData) {
			if (resData.status === 1) {
				this.monitorStatusStr = '真棒，实时监测中';
				if (!resData.isOffline) {
					this.monitorStatusStr = '监测仪离线';
				} else {
					if (!resData.isSignal) {
						this.monitorStatusStr = '信号似乎不太好哦';
					} else {
						if (resData.stableNum <= 59) {
							this.monitorStatusStr = '动作有点大哦，现在的呼吸率和心率不稳定，请尽量保持稳定';
						}
						if (resData.stableNum >= 60 && resData.stableNum <= 79) {
							this.monitorStatusStr = '您正在接近稳定噢，再努力一点点';
						}
						if (resData.stableNum >= 80) {
							this.monitorStatusStr = '真棒，实时监测中';
						}
						if (resData.tcfg === 1) {
							this.monitorStatusStr = '距离有点近哦，请调整与设备的距离';
						}
					}
				}
			} else if (resData.status === 2) {
				if (this.detailPageData.statusName == '疑似生命体征微弱') {
					this.monitorStatusStr = this.detailPageData.statusName;
				} else {
					this.monitorStatusStr = '已离床';
				}
			} else if (resData.status === 3) {
				this.monitorStatusStr = '监测仪离线';
			} else if (resData.status === 4) {
				this.monitorStatusStr = '监测关闭';
			} else if (resData.status === 5) {
				this.monitorStatusStr = '设备异常';
			}
		},
		// 获取渐变色结束颜色
		getEndColor(data) {
			this.stableNum = data;
			let colorArr = ['#CCA20F', '#BEA813', '#AEAE18', '#A2B520', '#95BB25', '#87BF29', '#7AC62E', '#6CC932', '#61CE36', '#65E332', '#65E332']
			let index = 0;
			if (data < 8) index = 0;
			if (data >= 8 && data < 16) index = 1;
			if (data >= 16 && data < 24) index = 2;
			if (data >= 24 && data < 32) index = 3;
			if (data >= 32 && data < 40) index = 4;
			if (data >= 40 && data < 48) index = 5;
			if (data >= 48 && data < 56) index = 6;
			if (data >= 56 && data < 64) index = 7;
			if (data >= 64 && data < 72) index = 8;
			if (data >= 72 && data < 80) index = 9;
			if (data >= 80) index = 10;
			this.endColor = colorArr[index];
		},
		computedBreathPosition(breathStatus, breathBpm) {
			let breathPositionStr = '';
			// 低
			if (breathBpm < breathStatus[0]) {
				this.isShowRedBreath = 1;
				breathPositionStr =
					(25 / 100 / breathStatus[0]) * breathBpm * 100 + '%';
			}
			// 中
			if (breathBpm >= breathStatus[0] && breathBpm <= breathStatus[1]) {
				this.isShowRedBreath = 2;
				breathPositionStr =
					(50 / 100 / (breathStatus[1] - breathStatus[0])) *
					(breathBpm - breathStatus[0]) *
					100 +
					25;
				if (breathPositionStr > 65) {
					breathPositionStr = 65;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			// 高
			if (breathBpm > breathStatus[1]) {
				this.isShowRedBreath = 3;
				breathPositionStr =
					(25 / 100 / breathStatus[0]) * (breathBpm - breathStatus[1]) * 100 +
					65;
				if (breathPositionStr > 90) {
					breathPositionStr = 90;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			if (breathBpm >= 255) {
				this.isShowRedBreath = 2;
				this.breathBPM = '--';
			}
			this.breathPosition = breathPositionStr;
		},
		computedHeartPosition(heartStatus, heartBpm = 0) {
			let breathPositionStr = '';
			// 低
			if (heartBpm < heartStatus[0]) {
				this.isShowRedHeart = 1;
				breathPositionStr = (25 / 100 / heartStatus[0]) * heartBpm * 100 + '%';
			}
			// 中
			if (heartBpm >= heartStatus[0] && heartBpm <= heartStatus[1]) {
				this.isShowRedHeart = 2;
				breathPositionStr =
					(50 / 100 / (heartStatus[1] - heartStatus[0])) *
					(heartBpm - heartStatus[0]) *
					100 +
					25;
				if (breathPositionStr > 65) {
					breathPositionStr = 65;
				}
				breathPositionStr = breathPositionStr + '%';
			}

			// 高
			if (heartBpm > heartStatus[1]) {
				this.isShowRedHeart = 3;
				breathPositionStr =
					(25 / 100 / heartStatus[0]) * (heartBpm - heartStatus[1]) * 100 + 65;
				if (breathPositionStr > 90) {
					breathPositionStr = 90;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			if (heartBpm >= 255) {
				this.isShowRedHeart = 2;
				this.heartBPM = '--';
			}
			this.heartPosition = breathPositionStr;
		},
		// 获取 cookie 信息
		getCookie(c_name) {
			var name = c_name + '=';
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = decodeURIComponent(ca[i].trim()); // 解码
				if (c.indexOf(name) == 0) {
					return JSON.parse(c.substring(name.length, c.length));
				}
			}
			return '';
		},
		// 转时分秒
		formatSeconds(value) {
			let result = parseInt(value);
			let h =
				Math.floor(result / 3600) < 10
					? '0' + Math.floor(result / 3600)
					: Math.floor(result / 3600);
			let m =
				Math.floor((result / 60) % 60) < 10
					? '0' + Math.floor((result / 60) % 60)
					: Math.floor((result / 60) % 60);
			let s =
				Math.floor(result % 60) < 10
					? '0' + Math.floor(result % 60)
					: Math.floor(result % 60);

			let res = '';
			res += `${h}:${m}:${s}`;

			return res;
		},
		swictchChangeLeaveBedTime(item, index) {
			let getFallLongTimeData = JSON.parse(JSON.stringify(this.getFallLongTimeData));
			if (getFallLongTimeData && getFallLongTimeData.timePeriods && getFallLongTimeData.timePeriods.length > 0) {
				if (getFallLongTimeData.timePeriods[index].outBedEnable == 0) {
					getFallLongTimeData.timePeriods[index].outBedEnable = 1;
				} else {
					getFallLongTimeData.timePeriods[index].outBedEnable = 0;
				}
			}
			this.getFallLongTimeData = getFallLongTimeData;
		},
		swictchChangeLeaveBedPhone(item, index) {
			let getFallLongTimeData = JSON.parse(JSON.stringify(this.getFallLongTimeData));
			if (getFallLongTimeData && getFallLongTimeData.timePeriods && getFallLongTimeData.timePeriods.length > 0) {
				if (getFallLongTimeData.timePeriods[index].outBedPhoneEnable == 0) {
					getFallLongTimeData.timePeriods[index].outBedPhoneEnable = 1;
				} else {
					getFallLongTimeData.timePeriods[index].outBedPhoneEnable = 0;
				}
			}
			this.getFallLongTimeData = getFallLongTimeData;
		},
	},
	beforeDestroy() {
		this.closeWebsocket();
		if (this.createDataInterval) {
			clearInterval(this.createDataInterval);
			this.createDataInterval = null;
		}
		if (this.leaveBedInterval) {
			clearInterval(this.leaveBedInterval);
			this.leaveBedInterval = null;
		}
	},
	watch: {
		pageBottomData(newVal, oldVal) {
			if (newVal) {
				this.switchStatus = newVal.monitorInfoVO.onOff === 0 ? false : true;
				this.bedSetId = newVal.bedId;
				this.radarId = newVal.radarId;
			}
		}
	},
};
</script>
<style lang="scss" scoped>
.room-page {
	height: 383px;
	background: #fff;
	display: flex;
	width: 100%;
	border-radius: 0 0 8px 8px;
}
</style>
